export default __webpack_public_path__ + "5bfc100511ea414841b4b2b33e08410b.png";